/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontRichiesteIdImmaginiIdDimensioni =
  (typeof GetFrontRichiesteIdImmaginiIdDimensioni)[keyof typeof GetFrontRichiesteIdImmaginiIdDimensioni];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontRichiesteIdImmaginiIdDimensioni = {
  ICONA: 'ICONA',
  ANTEPRIMA: 'ANTEPRIMA',
  ORIGINALE: 'ORIGINALE',
} as const;
